import { useQuery } from '@tanstack/react-query';
import api from '../lib/api';

export interface SearchResult {
  id: string;
  title: string;
  snippet: string;
  updatedAt: number;
}

export function useSearch(query: string) {
  return useQuery({
    queryKey: ['search', query],
    queryFn: async () => {
      if (query.trim().length < 2) return [];
      const { data } = await api.get<{ data: SearchResult[] }>(`/search?q=${encodeURIComponent(query)}`);
      return data.data;
    },
    enabled: query.trim().length >= 2,
  });
}
